import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const   Expenses = (props) => {
  const { expenses,search,SUPPLIERS } = props;




    const checkIfExpenseItemsTitlesContainsSearch = (expense) => {
      //check for expenseItems in expense
        for(let i = 0; i < expense.expenseItems.length; i++){
            if(expense.expenseItems[i].title.toLowerCase().includes(search.toLowerCase())
            ){
                return true
            }
        }
    }

    const checkIfExpenseSuppliersNameContainsSearch = (expense) => {
       //check expense paidsuppliers and check if their name contains search by comparing ids with SUPPLIERS
        for(let i = 0; i < expense.paidSuppliers.length; i++){
            for(let j = 0; j < SUPPLIERS.length; j++){
                // console.log(expense.paidSuppliers[i].supplier , SUPPLIERS[j]._id)
                if(expense.paidSuppliers[i].supplier=== SUPPLIERS[j]._id){
                    if(SUPPLIERS[j].name.toLowerCase().includes(search.toLowerCase())){
                        return true
                    }
                }
            }
        }
    }


  return (

    <table className="table">
      <thead>
      <tr>
          <th scope="col">Seller Name</th>
          <th scope="col">Expense Title</th>
          <th scope="col">Total</th>
          <th scope="col">Paid</th>
          <th scope="col">Due</th>
          <th scope="col">Date</th>
          <th>Status</th>
          <th scope="col" className="text-end">
              Action
          </th>
      </tr>
      </thead>
      <tbody>
        {
            expenses.filter(expense => (expense.user.name).toLowerCase().includes(search.toLowerCase())
            || expense.user.email.toLowerCase().includes(search.toLowerCase())
            || expense.expenseTotalPrice.toString().includes(search.toLowerCase())
                    || expense.expensePaidAmount.toString().includes(search.toLowerCase())
                    || expense.expenseDueAmount.toString().includes(search.toLowerCase())
                || checkIfExpenseItemsTitlesContainsSearch(expense) ||
                checkIfExpenseSuppliersNameContainsSearch(expense)
            ).
        map((expense) => (
                <tr key={expense._id}>
                    <td>{expense.user.name}</td>
                    <td>
                        <b>{expense.expenseTitle}</b>
                    </td>
                    <td> {expense.expenseTotalPrice} TND</td>
                    <td> {expense.expensePaidAmount} TND</td>
                    <td> {expense.expenseDueAmount} TND</td>
                    <td>
                        {expense.expenseTotalPrice===expense.expensePaidAmount?
                            <span className="badge  rounded-pill  alert-success">Paid</span>
                            :
                            <span className="badge rounded-pill  alert-danger">Not Paid</span>
                        }

                    </td>
                    <td>{moment(expense.createdAt).format("MMM Do YY")}</td>

                    <td className="d-flex justify-content-end align-item-center">
                        <Link to={`/expense/${expense._id}`} className="text-success">
                            <i className="fas fa-eye"></i>
                        </Link>
                    </td>
                </tr>
        ))}

      </tbody>
    </table>
  );
};

export default Expenses;
